import React, { useState, useEffect } from 'react';
import { Col, Typography } from 'antd';
import { useHistory } from 'react-router-dom';
import { formatDate } from '../../utilities';

const VideoList = ( props ) => {


    const { Title } = Typography;
    const history = useHistory();
    const  { nombre,horario, id, descripcion  } = props.data;
    const [ fechaHoy, setFechaHoy ] = useState( new Date().getTime() )
    let fechaInicio = horario.toDate().getTime();

    useEffect( () => {
        setTimeout( () => {
            setFechaHoy( new Date().getTime() )
        }, 60000 - (new Date().getSeconds() * 1000)  )
    }, [ fechaHoy ] );

    return (
        <>
            <Col
                
                xs={{  span: 24, offset: 0 }} 
                sm={{  span: 24, offset: 0 }} 
                md={{  span: 24, offset: 0 }} 
                lg={{  span: 24, offset: 0 }}  
                xxl={{ span: 24, offset: 0 }}
            >
                <div
                    className="sn-list-item"
                    onClick={ () => history.push(`/video?id=${id}`) }
                    style={{ 
                        opacity: fechaHoy >= fechaInicio ? 1 : 0.5,
                    }}
                >   
                    <Title level={4}>{nombre}</Title>
                    <p className="desc">{descripcion}</p>
                    <p className="meta">
                        {formatDate(horario.toDate())}
                    </p>
                </div>
            </Col>
        </>
    )
}

export default VideoList
